// Copyright (c) StrangeBee 2024

import { Route as AlertsLayoutRoute } from './Details';
import { Route as AlertsListRoute } from './List';

export const Routes = [AlertsLayoutRoute, AlertsListRoute];
